export default "__VITE_ASSET__G86O9Kpl__"